module.exports = __webpack_public_path__ + "img/slider_2.ab10669f.webp";